import { useLang } from "../../lib/i18n";

export const Marquee = () => {
  const { t, lang } = useLang();
  return (
  <div className="relative overflow-hidden border-y border-white/[0.07] py-6" data-testid="marquee" dir="ltr">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {t.marquee.map((w, i) => (
            <span key={w} dir={lang === "ar" ? "rtl" : "ltr"} className="flex items-center font-display text-3xl font-bold uppercase tracking-tight sm:text-5xl">
              <span className={i % 2 ? (lang === "ar" ? "text-accent" : "text-outline") : "text-white"}>{w}</span>
              <span className="mx-8 inline-block h-3 w-3 rotate-45 bg-accent2" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
  );
};
